import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { PointLight } from "three";
import { hitFlashSlots } from "../game/hitFlash";

// Always-mounted pool of impact-flash lights — see hitFlash.ts for why this
// has to be a fixed pool rather than one pointLight per hit. Mount this once,
// outside GameManager/SurvivalManager (which unmount per phase) and
// definitely outside <Block> (which mounts/unmounts per spawned note).
export function HitFlashPool() {
  const lightRefs = useRef<(PointLight | null)[]>([]);

  useFrame(() => {
    for (let i = 0; i < hitFlashSlots.length; i++) {
      const light = lightRefs.current[i];
      if (!light) continue;
      const slot = hitFlashSlots[i];
      light.position.copy(slot.position);
      light.color.set(slot.color);
      light.intensity = slot.intensity;
    }
  });

  return (
    <>
      {hitFlashSlots.map((_, i) => (
        <pointLight
          key={i}
          ref={(el) => {
            lightRefs.current[i] = el;
          }}
          intensity={0}
          distance={2.5}
        />
      ))}
    </>
  );
}
